import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '@/components/Home'
import Home from '@/components/HomeV2'
// import Directorio from '@/components/Directorio'
import Directorio from '@/components/DirectorioV2'
// import Home from '@/components/DirectorioV2'
// import Lugar from '@/components/Directorio/Lugar'
import Lugar from '@/components/DirectorioV2/Lugar'
import Eventos from '@/components/Eventos'
// import Evento from '@/components/Eventos/Evento'
import Evento from '@/components/DirectorioV2/Evento'
import Bus from '@/components/DirectorioV2/Turibus'
import Vision from '@/components/VisionV2'
import Ayuda from '@/components/AyudaV2'

import Download from '@/components/Download'

import Dashboard from '@/components/Dashboard'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'root',
    component: Home,
    redirect: { name: 'home', params: { ciudad: 'juarez' } }
  },
  {
    path: '/home/:ciudad',
    name: 'home',
    component: Home
  },
  {
    path: '/directorio/:tipo/city/:ciudad',
    name: 'directorio',
    component: Directorio,
    props: true,
    children: [
      {
        path: 'lugar/:hash',
        name: 'lugar',
        component: Lugar,
        props: true
      },
      {
        path: 'evento/:hash',
        name: 'evento',
        component: Evento,
        props: true
      },
      {
        path: 'turibus/:hash',
        name: 'turibus',
        component: Bus,
        porps: true
      }
    ]
  },
  {
    path: '/eventos/:ciudad',
    name: 'eventos',
    component: Eventos,
    props: true
  },
  // {
  //   path: '/evento/:hash',
  //   name: 'evento',
  //   component: Evento,
  //   props: true
  // },
  {
    path: '/vision',
    name: 'vision',
    component: Vision,
    props: true
  },
  {
    path: '/que-es-bpx',
    name: 'ayuda',
    component: Ayuda,
    props: true
  },
  {
    path: '/landing/:influencer',
    name: 'landing',
    component: Download
  },
  {
    path: '/landing',
    name: 'landing-no-param',
    component: Download
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    props: true
  },
  {
    path: '/maps/:hash_inicio/:hash_destino/:lat_inicio/:lng_inicio/:lat_destino/:lng_destino',
    // path: '/maps/:hash-inicio/:hash-destino/:lat-inicio/:lng-inicio/:lat-destino/:lng-destino',
    name: 'maps',
    component: Download
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
